import { defineComponent, ref, computed } from 'vue-demi';
import { G as hslToColorString, F as generateHslFromString } from './color-591c5547.js';
import { s as script$1 } from './OrIcon-9aff520e.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, normalizeStyle, renderSlot, createBlock, createCommentVNode } from 'vue';

var AvatarSize;
(function (AvatarSize) {
  AvatarSize["XL"] = "xl";
  AvatarSize["L"] = "l";
  AvatarSize["M"] = "m";
  AvatarSize["S"] = "s";
  AvatarSize["XS"] = "xs";
})(AvatarSize || (AvatarSize = {}));
var AvatarColor;
(function (AvatarColor) {
  AvatarColor["Auto"] = "auto";
  AvatarColor["Blue"] = "blue";
  AvatarColor["Grey"] = "grey";
  AvatarColor["Green"] = "green";
  AvatarColor["Yellow"] = "yellow";
  AvatarColor["Red"] = "red";
})(AvatarColor || (AvatarColor = {}));

const Avatar = [
// Layout
'layout-inline-row justify-center',
// Overflow
'overflow-hidden',
// Interactivity
'interactivity-default',
// Shape
'rounded-full'];
const AvatarSizes = {
  [AvatarSize.XL]: [
  // Box
  'w-[80px]', 'h-[80px]'],
  [AvatarSize.L]: [
  // Box
  'w-[64px]', 'h-[64px]'],
  [AvatarSize.M]: [
  // Box
  'w-[40px]', 'h-[40px]'],
  [AvatarSize.S]: [
  // Box
  'w-[32px]', 'h-[32px]'],
  [AvatarSize.XS]: [
  // Box
  'w-[24px]', 'h-[24px]']
};
const AvatarIconSizes = {
  [AvatarSize.XL]: [
  // Typography
  'text-[40px]'],
  [AvatarSize.L]: [
  // Typography
  'text-[32px]'],
  [AvatarSize.M]: [
  // Typography
  'text-[20px]'],
  [AvatarSize.S]: [
  // Typography
  'text-[16px]'],
  [AvatarSize.XS]: [
  // Typography
  'text-[16px]']
};
const AvatarTextSizes = {
  [AvatarSize.XL]: [
  // Typography
  'typography-headline-1'],
  [AvatarSize.L]: [
  // Typography
  'typography-headline-1'],
  [AvatarSize.M]: [
  // Typography
  'typography-body-1-bold'],
  [AvatarSize.S]: [
  // Typography
  'typography-body-1-bold'],
  [AvatarSize.XS]: [
  // Typography
  'typography-caption-semibold']
};
const AvatarColors = {
  [AvatarColor.Auto]: [
  // Theme
  'theme-foreground-base', 'dark:theme-foreground-base-dark'],
  [AvatarColor.Blue]: [
  // Theme
  'theme-foreground-on-primary', 'dark:theme-foreground-on-primary-dark', 'theme-background-primary', 'dark:theme-background-primary-dark'],
  [AvatarColor.Grey]: [
  // Theme
  'theme-foreground-on-secondary', 'dark:theme-foreground-on-secondary-dark', 'theme-background-secondary', 'dark:theme-background-secondary-dark'],
  [AvatarColor.Green]: [
  // Theme
  'theme-foreground-on-success', 'dark:theme-foreground-on-success-dark', 'theme-background-success', 'dark:theme-background-success-dark'],
  [AvatarColor.Yellow]: [
  // Theme
  'theme-foreground-on-warning', 'dark:theme-foreground-on-warning-dark', 'theme-background-warning', 'dark:theme-background-warning-dark'],
  [AvatarColor.Red]: [
  // Theme
  'theme-foreground-on-error', 'dark:theme-foreground-on-error-dark', 'theme-background-error', 'dark:theme-background-error-dark']
};

var script = defineComponent({
  name: 'OrAvatar',
  components: {
    OrIcon: script$1
  },
  props: {
    src: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: () => AvatarSize.M
    },
    color: {
      type: String,
      default: () => AvatarColor.Auto
    },
    colorSalt: {
      type: String,
      default: undefined
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-avatar-v3', ...Avatar, ...AvatarSizes[props.size], ...(props.icon ? AvatarIconSizes[props.size] : AvatarTextSizes[props.size]), ...AvatarColors[props.color]]);
    // Inline styles
    const rootInlineStyles = computed(() => {
      var _a;
      return {
        background: props.color === AvatarColor.Auto && !props.src ? hslToColorString(generateHslFromString((_a = props.colorSalt) !== null && _a !== void 0 ? _a : '')) : undefined
      };
    });
    return {
      root,
      rootStyles,
      rootInlineStyles
    };
  }
});

const _hoisted_1 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    style: normalizeStyle(_ctx.rootInlineStyles)
  }, [renderSlot(_ctx.$slots, "default", {}, () => [_ctx.src ? (openBlock(), createElementBlock("img", {
    key: 0,
    class: normalizeClass(['w-full', 'h-full', 'object-cover']),
    src: _ctx.src,
    alt: ''
  }, null, 8 /* PROPS */, _hoisted_1)) : _ctx.icon ? (openBlock(), createBlock(_component_OrIcon, {
    key: 1,
    icon: _ctx.icon,
    size: 'inherit'
  }, null, 8 /* PROPS */, ["icon"])) : createCommentVNode("v-if", true)])], 6 /* CLASS, STYLE */);
}

script.render = render;
script.__file = "src/components/or-avatar-v3/OrAvatar.vue";

export { AvatarSize as A, AvatarColor as a, script as s };
